import { FIELDS, TAB_VIEW_SECTIONS, TABS } from '../../../../constants';

const NOTES_FEATURES_FIELDS =
  FIELDS[TABS.OVERVIEW][TAB_VIEW_SECTIONS[TABS.OVERVIEW].FEATURES];

export const {
  NOTES: NOTES_FIELD,
  LOCATIONS: LOCATIONS_FIELD,
  UNITS: UNITS_FIELD,
  COMMUNITY: COMMUNITY_FIELD,
} = NOTES_FEATURES_FIELDS;

export const FIELD_LABELS = {
  [NOTES_FIELD]: 'Notes',
  [LOCATIONS_FIELD]: 'Locations',
  [UNITS_FIELD]: 'Units',
  [COMMUNITY_FIELD]: 'Community',
};

export const FIELDS_PLACEHOLDERS = {
  [NOTES_FIELD]:
    'e.g. 1 month free on 12-month lease, agent instructions, or property access details',
  [LOCATIONS_FIELD]: 'e.g. Parks, Restaurants',
  [UNITS_FIELD]: 'e.g. Walk-in Closets, Newly Renovated',
  [COMMUNITY_FIELD]: 'e.g. Gym, Pool',
};

/** Field names for key-feature chip rows (order matches UI). */
export const KEY_FEATURE_CHIP_FIELD_NAMES = [
  LOCATIONS_FIELD,
  UNITS_FIELD,
  COMMUNITY_FIELD,
];
